import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";
import { AccountPassword } from "../organisms/AccountPassword";
import { AccountProfile } from "../organisms/AccountProfile";
import { TwoFactorAuthSettings } from "../organisms/TwoFactorAuthSettings";
import { useUserContext } from "../hooks/useUserContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "~/atoms/tabs";

export const AccountTab = {
  password: "password",
  profile: "profile",
  twoFA: "twoFA",
};

export const AccountSettings = () => {
  const [searchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");

  const { user } = useUserContext();
  const { t } = useTranslation();

  return (
    <div className="container">
      <h3 className="py-7 text-4xl font-semibold">
        {t(($) => $.settings.header)}
      </h3>

      <div className="rounded-lg bg-white p-6 shadow-md">
        <Tabs defaultValue={tabParam ?? AccountTab.profile}>
          <TabsList className="mb-5 grid w-[600px] grid-cols-3">
            <TabsTrigger value={AccountTab.profile}>
              {t(($) => $.settings.profile.header)}
            </TabsTrigger>
            <TabsTrigger value={AccountTab.password} hidden={user.isSsoEnabled}>
              {t(($) => $.settings.password.header)}
            </TabsTrigger>
            <TabsTrigger value={AccountTab.twoFA} hidden={user.isSsoEnabled}>
              {t(($) => $.settings["2fa"].header)}
            </TabsTrigger>
          </TabsList>
          <TabsContent value={AccountTab.profile}>
            <AccountProfile />
          </TabsContent>
          <TabsContent value={AccountTab.password}>
            <AccountPassword />
          </TabsContent>
          <TabsContent value={AccountTab.twoFA}>
            <TwoFactorAuthSettings />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};
